import { get, post, put } from '@/utils/request'

// const TYPE = 'JSON'
// const TOKEN = 'r-Damkh1bBVbOUtvwJarY_YCUXjlXmKxMYAJnl66taIjmQ2GHtjsiw'

// 获取短信验证码
export const getSmsCode = params => get('/user/sendSmsCode', params)
// 获取图形验证码
export const getImgCode = params => get('/imageCode', params)
// 登录
export function doLogin(params) {
    return post('/user/userLogin', params)
}
// 登出
export function doLogout() {
    return post('/user/userLogout')
}
// 获取当前用户信息
export const getCurrentUserInfo = () => get(`/user/currentUserDetail`)

// 校验图形验证码
// export function checkImgCode(params) {
//     return post('/login/check', params)
// }
// 发送短信验证码
export function sendSmsCode(params) {
    return post('/user/sendSmsCode', params)
}
// 修改密码
export function updatePassword(params) {
    return put('/operate-user/updateUserPwd', params)
}
// 重置密码
export function resetPassword(params) {
    return post('/login/password/reset', params)
}
// 校验用户是否存在
export function checkPhoneExist(params) {
    return post('customer/check/checkPhoneOrUserName', params)
}
